import { createFileRoute } from '@tanstack/react-router';
import { UnidadesPage } from '@/components/unidades';

export const Route = createFileRoute('/_app/cadastros/unidades')({
  component: UnidadesPage,
});
